import Axios from "axios";
import Endpoints from "@/config/ApiEndpoints.js";

export function confirmSuspiciousMileage(vm, message) {
  return vm.$swal
    .fire({
      title: "Are you sure this mileage is correct?",
      text:
        message ||
        "The entered mileage is significantly different from this vehicle's historical mileage.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, it's correct",
      cancelButtonText: "No, change mileage",
      reverseButtons: true,
      allowOutsideClick: false,
    })
    .then((result) => !!result.isConfirmed);
}

export function requestMileageValidation(payload) {
  return Axios.post(Endpoints.Vehicle.ValidateMileage, {
    token: localStorage.getItem("token"),
    ...payload,
  });
}

/**
 * Run backend mileage validation, then either save or show the confirm dialog.
 * Continue sets mileageConfirmed so the following save (and the backend
 * Create/Update guard) does not warn again for the same value.
 */
export function confirmMileageThen(vm, payload, saveFn, onCancel) {
  const mileage = payload.current_mileage;
  if (
    vm.mileageConfirmed &&
    String(vm.confirmedMileageValue) === String(mileage)
  ) {
    saveFn();
    return;
  }

  if (mileage === "" || mileage === null || typeof mileage === "undefined") {
    saveFn();
    return;
  }

  requestMileageValidation(payload)
    .then((Response) => {
      if (Response?.data?.warning) {
        return confirmSuspiciousMileage(vm, Response.data.message).then(
          (confirmed) => {
            if (confirmed) {
              vm.mileageConfirmed = true;
              vm.confirmedMileageValue = mileage;
              saveFn();
            } else if (typeof onCancel === "function") {
              onCancel();
            }
          }
        );
      }
      saveFn();
    })
    .catch(() => {
      saveFn();
    });
}
